define('main',[
	"jquery",
	"underscore",
	"moduleLoader",
	"scorebootstrap",
	"LNRS/Track/AnalyticsDispatcher",
	"LNRS/Adobe/AdobeScript",
	"eventManager",
	"Utility/ErrorHandler",
	"Globalization/Dictionary",
	"matchHeight",
	"dotdotdot",
	"promise-polyfill",
], function (
	$,
	_,
	moduleLoader,
	scorebootstrap,
	dispatcher,
	adobe,
	eventManager,
	errorHandler,
	dictionary
) {
	("use strict");

	setTimeout(function () {
		var bodyHeight = $("body").height();
		var headerHeight = $("header").height();
		var footerHeight = $("footer").height();

		var contentHeight = bodyHeight - (headerHeight + footerHeight);
		if (contentHeight < 400) {
			var pageId = $("body").attr("data-page-id");
			var pageVersion = $("body").attr("data-page-version");
			var language = $("body").attr("data-page-language-name");
			errorHandler.logError(
				"Content smaller than 400px url: " +
					window.location +
					" pageId: " +
					pageId +
					" pageVesion: " +
					pageVersion +
					" language: " +
					language
			);
		}
	}, 1000);

	//LNRSSUP-723
	var hash = $(location).attr("hash");
	if (hash) {
		var containsGnav = hash.toLowerCase().includes("gnav");
		if (!containsGnav) {
			if (hash.indexOf("/") > -1) {
				hash = hash.split("/")[0];
				var anchor = $(hash);
				if (anchor) {
					window.addEventListener("load", function () {
						window.location.hash = hash;
						window.location = window.location;
					});
				}
			} else {
				window.location = window.location;
				window.addEventListener("load", function () {
					window.location = window.location;
				});
			}
		}
	}
	//LNRSSUP-723-END

	function getUrlParameter(sParam) {
		var sPageURL = window.location.search.substring(1),
			sURLVariables = sPageURL.split("&"),
			sParameterName,
			i;

		for (i = 0; i < sURLVariables.length; i++) {
			sParameterName = sURLVariables[i].split("=");

			if (sParameterName[0] === sParam) {
				return sParameterName[1] === undefined
					? true
					: decodeURIComponent(sParameterName[1]);
			}
		}
		return "";
	}

	//LNRSSUP-630
	var lnrsvpn = getUrlParameter("lnrsvpn");
	if (lnrsvpn != null && lnrsvpn.length > 0) {
		if (lnrsvpn.toLowerCase().includes("true")) {
			document.cookie =
				"lnrsvpn=true; expires=Fri, 31 Dec 9999 23:59:59 GMT;path=/";
		}
	}
	//LNRSSUP-630-END

	//LNRSSUP-690
	var trmid = getUrlParameter("trmid");
	if (trmid != null && trmid.length > 0) {
		var numOfDots = trmid.match(/\./g);
		if (numOfDots != null && numOfDots.length === 3) {
			//set cookie that expires in 60mins
			var date = new Date();
			var minutes = 60;
			date.setTime(date.getTime() + minutes * 60 * 1000);
			document.cookie =
				"trmid=" + trmid + ";expires=" + date.toGMTString() + ";path=/";
		}
	}
	//LNRSSUP-690 - END

	// Pattern library dropdown menu animation
	$(".pattern-library-page .dropdown-toggle").click(function () {
		$(this).next(".dropdown-menu").slideToggle(100);
	});

	//3-lvl-tab data-parent attribute setup START
	$.each($(".first-level-lnrs-tab-item"), function (index, value) {
		var parent = $(value).closest(".first-level-lnrs-tab-parent");
		var parentId = $(parent).attr("id");
		$(value).attr("data-parent", "#" + parentId);
	});
	$.each($(".second-level-lnrs-tab-item"), function (index, value) {
		var parent = $(value).closest(".second-level-lnrs-tab-parent");
		var parentId = $(parent).attr("id");
		$(value).attr("data-parent", "#" + parentId);
	});
	//3-lvl-tab data-parent attribute setup END

	//LNRSSUP-300
	var ytiframes = $(".score-youtube-video").find("iframe");
	$.each(ytiframes, function (index, ytiframe) {
		var src = $(ytiframe).attr("src");
		if (src.indexOf("&rel=0") == -1) {
			$(ytiframe).attr("src", src + "&rel=0");
		}
	});
	//end-LNRSSUP-300

	/*
	 *  infographics fix background color for headers
	 *  that have a line that has to be hidden
	 */
	if ($(".infographic").length) {
		var infoBgColor = $(".infographic").css("background-color");
		if (infoBgColor == "rgba(0, 0, 0, 0)") {
			infoBgColor = "rgb(255,255,255)";
		}
		$(
			".infographic .score-style-box.right-to-left .score-section-header h2"
		).css("background-color", infoBgColor);
		$(
			".infographic .score-style-box.left-to-right .score-section-header h2"
		).css("background-color", infoBgColor);
	}

	/*
	 *  Dark highlights scroll in text in box
	 *
	 */
	function initDarkHighlights() {
		if ($(".lnrs-dark-highlights").length) {
			// $('.lnrs-dark-highlights .score-highlight').matchHeight();
			$(window).scroll(function (e) {
				var winPos = $(window).scrollTop() + $(window).height() - 100;
				var highlightPos = $(".lnrs-dark-highlights .score-highlight").offset()
					.top;
				if (
					winPos >= highlightPos &&
					!$(".dark-highlights .score-highlight").hasClass("show-text")
				) {
					$(
						".lnrs-dark-highlights .score-column4 > div:first-child .score-highlight"
					).addClass("show-text");
					setTimeout(function () {
						$(
							".lnrs-dark-highlights .score-column4 > div:nth-child(2) .score-highlight"
						).addClass("show-text");
					}, 500);
					setTimeout(function () {
						$(
							".lnrs-dark-highlights .score-column4 > div:nth-child(3) .score-highlight"
						).addClass("show-text");
					}, 1000);
					setTimeout(function () {
						$(
							".lnrs-dark-highlights .score-column4 > div:nth-child(4) .score-highlight"
						).addClass("show-text");
					}, 1500);
				}
			});
		}
	}
	initDarkHighlights();

	//js startsWith polyfill for older js/browser implementations
	if (!String.prototype.startsWith) {
		String.prototype.startsWith = function (searchString, position) {
			position = position || 0;
			return this.indexOf(searchString, position) === position;
		};
	}

	//Have to move highlight header to caption for .highlight-card.horizontal
	let moveHighlightHeader = function moveHighlightHeader() {
		if (
			document.querySelector(".highlight-card.horizontal") &&
			window.innerWidth > 991
		)
			document
				.querySelectorAll(".highlight-card.horizontal")
				.forEach(function (el) {
					let header = el.querySelector(".score-highlight-header");
					let caption = el.querySelector(".caption");
					caption.prepend(header);
				});
	};
	Promise.resolve().then(moveHighlightHeader);

	//prevents dropdown from closing when clicked inside
	$(document).on("click", ".score-megamenu .dropdown-menu", function (e) {
		e.stopPropagation();
	});

	$("body").addClass("body-visible");

	// detect use of keyboard
	document.body.addEventListener("mousedown", function () {
		document.body.classList.remove("using-kbd");
	});
	document.body.addEventListener("keydown", function (event) {
		if (event.key === "Tab") {
			document.body.classList.add("using-kbd");
		}
	});

	var parseQueryString = function () {
		var str = window.location.href;
		var objURL = {};

		str.replace(
			new RegExp("([^?=&]+)(=([^&]*))?", "g"),
			function ($0, $1, $2, $3) {
				objURL[$1] = $3;
			}
		);
		return objURL;
	};

	var params = parseQueryString();
	var scMode = params["sc_mode"];
	if (scMode) {
		$("body > div.page-wrapper").addClass(scMode);
	}

	//Fix for the Button in IE for PDF download too large
	//$(".score-composite-link.btn-red:contains('Download PDF')").css("display", "inline"); // style breakes layout

	// match height style boxes within a container with a special "signal" class
	$.fn.matchHeight._maintainScroll = true;
	//$('.matchheight-stylebox .score-style-box').matchHeight();
	//$('.row-stripe .score-highlight, .row-stripe .score-style-box').matchHeight();
	$(".masonry-resource-listing-item").matchHeight();
	//$('.press-room-grid-item').matchHeight();
	//$('.full-width .score-style-box, .score-highlight, .score-section-hero').matchHeight();
	$(".grey-rail .score-left, .grey-rail .score-right").matchHeight(); // do not remove - needed for grey-rail columns for page layouts
	$(".highlight-row").matchHeight("remove");
	$(".score-right .score-right").matchHeight("remove");
	$(".mantle-no-box-left-bottom-margin").matchHeight("remove");

	eventManager.subscribe("MatchHeightRefresh", function () {
		$.fn.matchHeight._update();
	});

	// $('.with-dividers > div').matchHeight();

	function facetCollapse() {
		$(".score-left").on("click", ".btn-filter", function (e) {
			e.preventDefault();
			if ($(window).width() >= 992) return;
			$(".search-filters").slideToggle();
		});
	}

	/*
		$(".btn-filter").on("click", function (e) {
			e.preventDefault();
		});
		$(".score-left").off("click");
		if ($(window).width() < 992) {
			$(".score-left").on("click", ".btn-filter", function () {
				$(this).next(".search-filters").slideToggle();
			});
		}
			*/

	$("footer").on("click", ".score-lead", function () {
		var $this = $(this);
		$("footer .score-lead, footer .score-menu-list").removeClass("open");
		if (!$this.hasClass("open")) {
			$this.addClass("open").next().addClass("open");
		}
	});

	$(".score-megamenu-dropdown .score-style-box a.back-menu").on(
		"click",
		function (e) {
			$(e.currentTarget)
				.parents(".score-megamenu-dropdown")
				.removeClass("open");
		}
	);

	// LNRSSUP-1042 - One Trust banner injected scripts preventing  nav menu dropdown from opening fix
	$(".navbar-nav").on("click", "li.score-megamenu-dropdown", function (event) {
		var isBannerVisible =
			$("#onetrust-banner-sdk").length > 0 &&
			$('#onetrust-banner-sdk[style*="visibility: hidden"]').length === 0;

		// execute only if one trust banner is visible
		if (isBannerVisible) {
			// close banner
			var bannerCloseButton = $(".onetrust-close-btn-ui");
			if (bannerCloseButton.length > 0) {
				bannerCloseButton.click();
			}
		}
	});
	// init hamburger state
	$(".navbar-toggle").addClass("collapsed");

	//collapse accordion panels on page load
	$(".collapse.in").collapse("hide");

	var verticalOffsetToStart = 50;
	var didScroll = false;
	window.addEventListener("scroll", doOnScroll);

	headerHeightChange();

	function headerHeightChange() {
		if (
			!window.ExperienceEditor ||
			(window.ExperienceEditor && !window.ExperienceEditor.isInMode("edit"))
		) {
			if (
				window.pageYOffset > verticalOffsetToStart &&
				document.body.classList
			) {
				document.body.classList.add("scrolled");
			}

			if (
				window.pageYOffset <= verticalOffsetToStart &&
				document.body.classList
			) {
				document.body.classList.remove("scrolled");
			}
		}
	}

	function doOnScroll() {
		didScroll = true;
	}

	setInterval(function () {
		if (didScroll) {
			didScroll = false;
			headerHeightChange();
		}
	}, 100);

	/* Hacky fix to force lightSlider to refresh after dotdotdot runs */
	setTimeout(function () {
		$(window).resize();
	}, 5000);

	setTimeout(function () {
		$('a[data-toggle="tab"]').on("shown.bs.tab", function () {
			setTimeout(function () {
				// $('.tab-content .score-highlight').matchHeight();
			}, 0);
		});
	}, 1000);

	// Makes space for the header  if the cookies warning div is visible
	eventManager.subscribe("CookieDisclaimerAlertIsShown", function () {
		setTimeout(function () {
			var viewWidth = $(window).width();
			if (viewWidth <= 768) {
				$(".dropdown-menu").css("margin-top", "0px");
			} else {
				var height = $(".score-cookie-disclaimer-alert").get(0).offsetHeight;
				$(".dropdown-menu").css("margin-top", height + "px");
			}
		}, 1000);
	});

	eventManager.subscribe("CookieDisclaimerAlertIsClosed", function () {
		setTimeout(function () {
			$(".dropdown-menu").css("margin-top", "0px");
		}, 1000);
	});

	// Detect for IE
	function detectIE() {
		var ua = window.navigator.userAgent;
		var msie = ua.indexOf("MSIE ");
		if (msie > 0) {
			return parseInt(ua.substring(msie + 5, ua.indexOf(".", msie)), 10);
		}
		var trident = ua.indexOf("Trident/");
		if (trident > 0) {
			var rv = ua.indexOf("rv:");
			return parseInt(ua.substring(rv + 3, ua.indexOf(".", rv)), 10);
		}
		var edge = ua.indexOf("Edge/");
		if (edge > 0) {
			return parseInt(ua.substring(edge + 5, ua.indexOf(".", edge)), 10);
		}
		return false;
	}

	// Gets the browser's scrollbar size
	function getScrollBarWidth() {
		if (detectIE()) {
			return 0;
		}
		var inner = document.createElement("p");
		inner.style.width = "100%";
		inner.style.height = "200px";
		var outer = document.createElement("div");
		outer.style.position = "absolute";
		outer.style.top = "0px";
		outer.style.left = "0px";
		outer.style.visibility = "hidden";
		outer.style.width = "200px";
		outer.style.height = "150px";
		outer.style.overflow = "hidden";
		outer.appendChild(inner);
		document.body.appendChild(outer);
		var w1 = inner.offsetWidth;
		outer.style.overflow = "scroll";
		var w2 = inner.offsetWidth;
		if (w1 === w2) w2 = outer.clientWidth;
		document.body.removeChild(outer);
		return w1 - w2;
	}

	// Holds the browser's scrollbar size in localstorage
	if (!sessionStorage.getItem("browserScrollWidth")) {
		sessionStorage.setItem("browserScrollWidth", getScrollBarWidth());
	}

	// if you need to monkey patch anything in Score Bootstrap Initialization logic
	// here's where you would do it. Before calling to init(). Something like:
	// scorebootstrap.Accordion.init = function() { ... }
	facetCollapse();

	//lnrssup-878
	scorebootstrap.Accordion.activate = function () {
		$(".score-accordion").each(function () {
			// ToDo: not always it is desired that the first panel of the accordion is expanded. Shouldn't it be also controlled by the component authors?

			var $firstPanel = $(".panel", this).first();
			if (BrainJocks.BootstrapUI.Utils.isDeepLinked()) {
				var anchor = BrainJocks.BootstrapUI.Utils.getAnchor();
				var caseInsAnchor = $("a[href = '#collapse-" + anchor + "' i]");
				var panel = caseInsAnchor.parents(".panel")[0];

				$firstPanel = panel || $firstPanel;
			}

			$(".panel-collapse", $firstPanel).addClass("in");
			$('a[data-toggle="collapse"]', $firstPanel)
				.removeClass("collapsed")
				.attr("aria-expanded", true);
		});
	};

	scorebootstrap.TabSet.activate = function () {
		$(".score-tab").each(function () {
			var tabToActivate = $(this).find(".nav li a")[0]; // first

			if (BrainJocks.BootstrapUI.Utils.isDeepLinked()) {
				var anchor = BrainJocks.BootstrapUI.Utils.getAnchor().toLowerCase();
				var caseInsAnchor = $("a[href = '#tab-" + anchor + "' i]");
				var tab = $(this).find(caseInsAnchor)[0];

				tabToActivate = tab || tabToActivate;
			}

			$(tabToActivate).tab("show");
		});
	};

	function isPageEditor() {
		if (typeof Sitecore == "undefined") {
			return false;
		}
		if (
			typeof Sitecore.PageModes == "undefined" ||
			Sitecore.PageModes == null
		) {
			return false;
		}
		return Sitecore.PageModes.PageEditor != null;
	}

	scorebootstrap.TabSet.init = function () {
		$(".score-tab").each(function () {
			var tabComponent = $(this);

			var tabsNav = tabComponent.find(".nav").first();
			var tabsContent = tabComponent.find(".tab-content").first();
			if (!isPageEditor()) {
				tabsNav.empty();
			}

			tabsContent.children(".tab-pane").each(function () {
				var tabPane = $(this);

				var tabId = tabPane.prop("id");
				var tabTitle = tabPane.data("title");
				var anchorable = /^(true|1|yes)$/i.test(
					tabPane.data("anchorable") || ""
				);

				var li =
					'<li class="' +
					BrainJocks.BootstrapUI.TabSet.getHiddenClasses(this) +
					'"><a href="#' +
					tabId +
					'" data-toggle="tab" data-anchorable="' +
					anchorable +
					'">' +
					tabTitle +
					"</a></li>";

				tabsNav.append(li);
			});
		});
	};

	// init SCORE Bootstrap components (Tabsets, Accordions, Carousels, etc.)
	scorebootstrap.init();

	$(".panel-close .score-accordion-panel .panel-collapse").removeClass("in");
	$(".panel-close .score-accordion-panel .panel-title a").addClass("collapsed");

	moduleLoader.loadPendingModules().done(function () {
		// load adobe scripts
		adobe.init();
		// anything that needs to run globally when all modules are loaded goes here

		// Kill body scroll with nav open
		$(".score-megamenu-dropdown").on("show.bs.dropdown", function (e) {
			e.stopPropagation();
			$("body")
				.addClass("modal-open")
				.css(
					"padding-right",
					sessionStorage.getItem("browserScrollWidth") + "px"
				);
			$(".score-header").css(
				"padding-right",
				sessionStorage.getItem("browserScrollWidth") + "px"
			);
		});

		$(".score-megamenu-dropdown").on("hide.bs.dropdown", function (e) {
			if (sessionStorage.getItem("industrySection")) {
				return false;
			}
			e.stopPropagation();
			$("body").removeClass("modal-open").css("padding-right", "");
			$(".score-header").css("padding-right", "");
			return true;
		});

		$(".score-modal").on("show.bs.modal", function () {
			$(".score-header").css(
				"padding-right",
				sessionStorage.getItem("browserScrollWidth") + "px"
			);
		});

		$(".score-modal").on("hidden.bs.modal", function () {
			$(".score-header").css("padding-right", "");
		});
	});

	//Open Sign-In modal if qParam is present
	var qParam = "opensignin";
	var regexpr = new RegExp(qParam, "i");
	var qs = window.location.search;
	var match = qs.match(regexpr);
	if (match && match.length > 0) {
		eventManager.trigger("Open Sign In");
	}

	//Insight & Resources tiles clickable
	$(document).on(
		"click",
		".masonry-resource-listing-hits .masonry-resource-listing-item",
		function (e) {
			e.preventDefault();
			var url = $(this)
				.find(".masonry-resource-listing-item-link")
				.prop("href");
			console.log(url);
			window.location.href = url;
		}
	);

	//Insight & Resources Carousel tiles  clickable
	$(document)
		.find(".btn-clickable-area-double-activator")
		.each(function (i, button) {
			$(button)
				.clone()
				.removeClass("btn-clickable-area")
				.insertAfter($(button));
		});

	$(".share-button").click(function () {
		var parent = $(this).parent(".social-sharing.site");
		if ($(".social-sharing.site").hasClass("slide")) {
			$(".social-sharing.site").removeClass("slide");
		} else {
			$(".social-sharing.site").addClass("slide");
		}
	});

	$(".social-tracked").on("click", function (e) {
		if ($(this).data("name")) {
			var social_network_name = $(this).data("name").toLowerCase();
			var o;
			let parentContainer = $(this).closest('.social-sharing');
			let socialPosition = $(parentContainer).hasClass('site') ? 'global side' : 'page body'; 

			if (social_network_name == "email") {
				o = {
					site_events: { email_share: "true" },
					event_name: "share content",
					social_position: socialPosition,
				};
			} else {
				o = {
					site_events: { social_share: "true" },
					event_name: "share content",
					social_network: social_network_name,
					social_position: socialPosition,
				};
			}

			console.log("Track Analytics\n" + JSON.stringify(o, null, 4));

			window.digitalData.push(o);
		} else {
			Console.Log(
				"Error, .social-tracked, the attribute data-name was not found."
			);
		}
	});

	/*
	 * Scrollable container
	 * fixes (in CSS) width of first
	 * (hopefully the ONLY)
	 * DIV inside .scrollable conatines
	 * adds buttons and does the scrolling
	 */
	// add buttons
	if ($(".scrollable").length) {
		$.each($(".scrollable"), function () {
			var cInner = $(this).find("div:first");
			cInner.addClass("scroll-inner");
			if (cInner.hasClass("complex-chart")) {
				$(this).append('<div class="scroll-prev linear"></div>');
				$(this).append('<div class="scroll-next linear"></div>');
			} else {
				$(this).append('<div class="scroll-prev steps"></div>');
				$(this).append('<div class="scroll-next steps"></div>');
				// position first highlight in center
				var outWidth = $(this).width();
				var scrollWidth = cInner.width();
				var innerEl = $(this).find(".custom-box");
				var innerElW = innerEl.outerWidth();
				var ddx = (scrollWidth - innerElW * innerEl.length) / 2;
				if (innerEl.length) {
					var dx = (outWidth - innerElW) / 2 - ddx;
					cInner.css("margin-left", dx + "px");
				}
			}
		});
	}

	// scroll in steps
	$(".scrollable").on("click", ".scroll-prev.steps", function (e) {
		var scrollBox = $(this).parent();
		var cInner = $(scrollBox).find(".scroll-inner");
		var arrowPrev = $(this);
		var arrowNext = $(scrollBox).find(".scroll-next");

		var outWidth = scrollBox.width();
		var scrollWidth = cInner.width();
		var scrollPos = parseFloat(cInner.css("margin-left"));
		var innerEl = scrollBox.find(".custom-box");
		var innerElW = innerEl.outerWidth();

		var ddx = (scrollWidth - innerElW * innerEl.length) / 2;

		if (innerEl.length) {
			var dx = (outWidth - innerElW) / 2 - ddx - innerElW * innerEl.length;
			var activeItem;
			for (activeItem = innerEl.length; activeItem >= 0; activeItem--) {
				if (dx > scrollPos) {
					break;
				}
				dx += innerElW;
			}

			if (activeItem == 0) {
				arrowPrev.hide();
			}
			//dx = (outWidth - innerElW)/2 - innerElW*activeItem - ddx;

			cInner.css("margin-left", dx + "px");
			arrowNext.show();
		}
	});

	$(".scrollable").on("click", ".scroll-next.steps", function (e) {
		var scrollBox = $(this).parent();
		var cInner = $(scrollBox).find(".scroll-inner");
		var arrowNext = $(this);
		var arrowPrev = $(scrollBox).find(".scroll-prev");

		var outWidth = scrollBox.width();
		var scrollWidth = cInner.width();
		var scrollPos = parseFloat(cInner.css("margin-left"));
		var innerEl = scrollBox.find(".custom-box");
		var innerElW = innerEl.outerWidth();

		var ddx = (scrollWidth - innerElW * innerEl.length) / 2;

		if (innerEl.length) {
			var dx = (outWidth - innerElW) / 2 - ddx + innerElW;
			var activeItem;
			for (activeItem = 0; activeItem < innerEl.length; activeItem++) {
				dx -= innerElW;
				if (dx < scrollPos) {
					break;
				}
			}

			if (activeItem >= innerEl.length - 1) {
				arrowNext.hide();
			}
			//dx = (outWidth - innerElW)/2 - innerElW*activeItem - ddx;

			cInner.css("margin-left", dx + "px");
			arrowPrev.show();
		}
	});

	// Linear scroll
	// show less
	$(".scrollable").on("click", ".scroll-prev.linear", function (e) {
		var scrollBox = $(this).parent();
		var scrollInnerBox = $(scrollBox).find(".scroll-inner")[0];
		var arrowPrev = $(this);
		var arrowNext = $(scrollBox).find(".scroll-next");

		var outerPos = scrollBox[0].getBoundingClientRect();
		var innerPos = scrollInnerBox.getBoundingClientRect();

		$(arrowNext).show();

		var dx = innerPos.x + outerPos.width;
		if (dx > 0) {
			dx = 0;
		}
		$(scrollInnerBox).css("margin-left", dx + "px");

		// hide next if at end
		if (dx == 0) {
			$(arrowPrev).hide();
		}
	});

	// show more
	$(".scrollable").on("click", ".scroll-next.linear", function (e) {
		var scrollBox = $(this).parent();
		var scrollInnerBox = $(scrollBox).find(".scroll-inner")[0];
		var arrowNext = $(this);
		var arrowPrev = $(scrollBox).find(".scroll-prev");

		var outerPos = scrollBox[0].getBoundingClientRect();
		var innerPos = scrollInnerBox.getBoundingClientRect();

		$(arrowPrev).show();

		var dx = innerPos.x - outerPos.x - outerPos.width;
		if (Math.abs(dx) + outerPos.width > innerPos.width) {
			dx = outerPos.width - innerPos.width;
		}
		$(scrollInnerBox).css("margin-left", dx + "px");

		// hide next if at end
		if (dx <= outerPos.width - innerPos.width) {
			$(arrowNext).hide();
		}
	});
	/*
	 *  End scrollable
	 */

	if ($("body").find("div.fixed-subnav").length) {
		$(".page-wrapper").addClass("sub-nav-visible");
	}

	/*
	 * LNRSSUP-1039 - Opening modal based on query parameter
	 * In order for this to work, 'url-query-value' attribute needs to be added to modal in Sitecore,
	 * as additional component property (parameter)
	 *
	 * LNRSSUP-1054 - One modal should be opened on load by default if no url parameter present
	 */
	var urlParams = new URLSearchParams(window.location.search);
	var modalWithOpenOnLoadAttr = $(".modal[open-on-load]")[0];

	if (urlParams.has("modal_id")) {
		var officerName = urlParams.get("modal_id");
		var re = RegExp(officerName, "i");

		var officerModal = $(".modal[url-query-value]").filter(function () {
			return re.test($(this).attr("url-query-value"));
		});

		if (officerModal.length > 0) {
			$(officerModal[0]).modal("show");
		}
	}
	// LNRSSUP-1054
	else {
		if (
			modalWithOpenOnLoadAttr !== undefined &&
			$(modalWithOpenOnLoadAttr).attr("open-on-load").toLowerCase() === "true"
		) {
			// LNRSSUP-1525
			var deleayTimerOpen = $(modalWithOpenOnLoadAttr).attr("delay-timer-open");

			if (
				deleayTimerOpen === undefined ||
				deleayTimerOpen === "" ||
				deleayTimerOpen === "0"
			) {
				$(modalWithOpenOnLoadAttr).modal("show");
			} else {
				let timeInSec = parseInt(deleayTimerOpen) * 1000;
				setTimeout(function () {
					$(modalWithOpenOnLoadAttr).modal("show");
				}, timeInSec);
			}
		}
	}

	// LNRSSUP-1123
	function setHighlightCardsHeight() {
		const highlightCards = document.querySelectorAll(".highlight-card");

		highlightCards.forEach((card) => {
			let parentRow = card.closest(
				'div[class*="score-column"][class$="equal"]'
			);

			if (!parentRow) {
				return;
			}

			if (parentRow.classList.contains("score-column1")) {
				return;
			}

			if (!parentRow.classList.contains("flex-row")) {
				parentRow.classList.add("flex-row");
			}

			if (parentRow.classList.contains("score-column2")) {
				let scoreLeft = document.querySelector(
					".flex-row .score-left:not(.flex-column)"
				);
				let scoreRight = document.querySelector(
					".flex-row .score-right:not(.flex-column)"
				);

				if (scoreLeft && scoreRight) {
					scoreLeft.classList.add("flex-column");
					scoreRight.classList.add("flex-column");
				}
			} else if (parentRow.classList.contains("score-column3")) {
				let scoreLeft = document.querySelector(
					".flex-row .score-left:not(.flex-column)"
				);
				let scoreCenter = document.querySelector(
					".flex-row .score-center:not(.flex-column)"
				);
				let scoreRight = document.querySelector(
					".flex-row .score-right:not(.flex-column)"
				);

				if (scoreLeft && scoreCenter && scoreRight) {
					scoreLeft.classList.add("flex-column");
					scoreCenter.classList.add("flex-column");
					scoreRight.classList.add("flex-column");
				}
			} else if (parentRow.classList.contains("score-column4")) {
				let scoreLeft = document.querySelector(
					".flex-row .score-left:not(.flex-column)"
				);
				let scoreCenter = document.querySelector(
					".flex-row .score-center:not(.flex-column)"
				);
				let scoreCenter2 = document.querySelector(
					".flex-row .score-center2:not(.flex-column)"
				);
				let scoreRight = document.querySelector(
					".flex-row .score-right:not(.flex-column)"
				);

				if (scoreLeft && scoreCenter && scoreCenter2 && scoreRight) {
					scoreLeft.classList.add("flex-column");
					scoreCenter.classList.add("flex-column");
					scoreCenter2.classList.add("flex-column");
					scoreRight.classList.add("flex-column");
				}
			}
		});
	}

	setHighlightCardsHeight();

	// LNRSSUP-1199
	function scrollToAccordionPanel(panel) {
		const rect = panel.getBoundingClientRect();
		const offsetTop = rect.top - $(".score-header").height();
		window.scrollBy(0, offsetTop);
	}

	// Open preselected accordion panel
	var accordionPanelHash = window.location.hash.substring(1);
	if (accordionPanelHash !== "") {
		var accordionPanelHrefElement = $(
			'[href="#collapse-' + accordionPanelHash + '"]'
		);

		if (accordionPanelHrefElement.length > 0) {
			var scoreAccordion =
				accordionPanelHrefElement.closest(".score-accordion");

			if (scoreAccordion.length > 0 && scoreAccordion.hasClass("panel-close")) {
				accordionPanelHrefElement.click();
			}
		}
	}

	const openAccordionPanel = $(".panel-collapse.collapse.in").closest(
		".panel.score-accordion-panel"
	)[0];
	var isContactUsPage = window.location.href.includes("contact-us");

	if (openAccordionPanel && isContactUsPage) {
		scrollToAccordionPanel(openAccordionPanel);
	}
	// LNRSSUP-1199 END

	// LNRSSUP-1275

	function getCookie(name) {
		var value = "; " + document.cookie;
		var parts = value.split("; " + name + "=");
		if (parts.length == 2) return parts.pop().split(";").shift();
		return "";
	}
	// Iterate over each element with class 'append-trmid' that has an 'href' attribute
	$(".append-trmid[href]").each(function () {
		// Get the current href value
		var currentHref = $(this).attr("href");

		var trmid = getCookie("trmid");

		if (trmid.length > 0) {
			// Check if the href already contains query parameters
			var separator = currentHref.indexOf("?") !== -1 ? "&" : "?";

			// Update or add the 'trmid' query parameter
			var updatedHref = currentHref + separator + "trmid=" + trmid;

			// Update the href attribute with the modified URL
			$(this).attr("href", updatedHref);
		}
	});
	// END LNRSSUP-1275

	// LNRSSUP-1455
	function updatePageReferrer() {
		var pageReferrerElements = $('[name="PageReferrer"]');
		if (pageReferrerElements.length === 0) return;

		var referrer = document.referrer;

		// Extract the last part of the referrer URL
		var referrerValue = "/";
		if (referrer) {
			// Extract the hostname from the referrer URL
			var referrerHostname = new URL(referrer).hostname;
			// Get the current page's hostname
			var currentHostname = window.location.hostname;

			if (referrerHostname === currentHostname) {
				var referrerPath = new URL(referrer).pathname;
				var segments = referrerPath.split("/").filter(function (segment) {
					return segment !== "";
				});

				referrerValue =
					segments.length > 0 ? "/" + segments[segments.length - 1] : "/";

				// Trim the trailing slash if it's not the only character
				if (referrerValue.length > 1 && referrerValue.endsWith("/")) {
					referrerValue = referrerValue.slice(0, -1);
				}
			} else {
				referrerValue = document.referrer;
			}

			$('[name="PageReferrer"]').val(referrerValue);
		}
	}

	updatePageReferrer();
	// END LNRSSUP-1455

	// START LNRSSUP-1468
	function pauseVimeoVideos() {
		var $vimeoIframes = $('iframe[src*="player.vimeo.com"]');

		if ($vimeoIframes.length > 0) {
			$vimeoIframes.each(function () {
				this.contentWindow.postMessage('{"method":"pause"}', "*");
			});
		}
	}

	$(".video-modal-button a").click(function () {
		$(".score-carousel").carousel("pause");
	});

	$("body").on("click", ".modal .close", function () {
		pauseVimeoVideos();
		$(".score-carousel").carousel("cycle");
	});

	var $modals = $(".score-carousel").find(".modal");

	if ($modals.length > 0) {
		var $newDiv = $("<div />")
			.attr("class", "video-modal-button last")
			.appendTo("body");
		$modals.first().appendTo($newDiv);
	}
	// END LNRSSUP-1468
	
	// LNRSSUP-1857 sinle silde carousel
	$('.custom-score-carousel .carousel-inner').each(function() {
		if ($(this).children().length === 1) {
			$(this).parent().addClass('single-slide');
		}
	});
	// end 1857

	// LNRSSUP-1471
	var backButtonText = dictionary.translate("Back");
	$(
		".score-header .dropdown-menu .score-megamenu-content > .score-column1 .score-center"
	).prepend(
		'<div class="back-wrapper"><button class="nav-back" data-toggle="dropdown">' +
			backButtonText +
			"</button></div>"
	);

	$(".score-header").on("click", ".nav-back", function () {
		$(".score-header .score-megamenu-dropdown").removeClass("open");
		$('.score-header .score-megamenu-dropdown > a[aria-expanded="true"]').attr(
			"aria-expanded",
			"false"
		);
	});
	// END LNRSSUP-1471

	// LNRSSUP-1483
	$(window).on("beforeunload", function (event) {
		const url = new URL(window.location);
		const searchParams = url.searchParams;

		if (searchParams.has("sc_trk")) {
			searchParams.delete("sc_trk");
			// Update the URL and history without reloading the page
			history.replaceState(null, "", url.pathname + url.search);
		}
	});
	// END LNRSSUP-1483

	// LNRSSUP-1513
	// new back button on third level navigation
	// Add the "Back" button only if it doesn't already exist
	$(".score-megamenu-content .tab-content .tab-pane").each(function () {
		if ($(this).find(".back-lvl2").length === 0) {
			$(this).prepend(
				'<div class="back-lvl2"><button class="nav-back1">' +
					backButtonText +
					"</button></div>"
			);
		}
	});

	// Handle "Back" button click
	$("body").on("click", ".back-lvl2 .nav-back1", function () {
		$(this)
			.closest(".tab-pane")
			.removeClass("active")
			.parent()
			.removeClass("open");
	});

	// Handle navigation tab click
	$("body").on("click", ".second-step .nav-pills li > a", function (e) {
		e.stopPropagation();

		var $this = $(this);
		var industryId = $this.attr("data-industryid");

		$(".second-step .nav-pills li").removeClass("active");
		$this.parent().addClass("active");

		$('*[id*="' + industryId + '"]')
			.addClass("active")
			.parent()
			.addClass("open");
	});
	// end LNRSSUP-1513

	//LNRSSUP-1654 Open PDF in new tab
		$('a[href$=".pdf"]').attr('target', '_blank');
	//

});

